import { ArrowForwardIosSharp } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceTemplate } from 'src/modules/invoice/models/invoiceTemplate';
import { FormatSection } from './formatSection';
import { SelectionWithProfilesSection } from './selectionWithProfilesSection';

type InvoiceTemplateInformationProps = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateInformation = (props: InvoiceTemplateInformationProps) => {
  const { invoiceTemplate } = props;
  const { t } = useTranslation(['invoice']);

  return (
    <Accordion disableGutters elevation={0}>
      <AccordionSummary
        expandIcon={<ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />}
        aria-controls={`panel-${invoiceTemplate?.name}-content`}
        id={`panel-${invoiceTemplate?.name}-header`}
      >
        <Typography sx={{ fontWeight: 500 }}>{t('invoice:adminInvoiceTemplatePage.templateInformation.templateInformation')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box ml={3} mr={3} mb={5}>
          <Typography sx={{ fontWeight: 500, color: 'text.secondary', mb: 1.5 }}>
            {t('invoice:adminInvoiceTemplatePage.templateInformation.selection')}
          </Typography>
          <SelectionWithProfilesSection />

          <Typography sx={{ fontWeight: 500, color: 'text.secondary', mb: 1 }}>
            {t('invoice:adminInvoiceTemplatePage.templateInformation.format')}
          </Typography>
          <FormatSection />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
